import CompletionScreen from './mastercard/CompletionScreen';
import usePaymentService from './hooks/usePaymentService.hook';
export { CompletionScreen };

export default usePaymentService;
